export const messageRevisionTypes = Object.freeze({
  EDIT: 'EDIT',
  DELETE: 'DELETE',
});
